export function isMatchingCondition(filteredConditions, sawlineConditions) {
    let allMatch = true;
    filteredConditions.forEach((filteredCondition) => {
        const hasExactMatch = sawlineConditions.includes(filteredCondition);

        const otherConditionsWithSameDatafield = sawlineConditions.filter(
            (sawlineCondition) => {
                return (
                    sawlineCondition != filteredCondition &&
                    sawlineCondition.datafield == filteredCondition.datafield
                );
            }
        );

        const isMatch =
            hasExactMatch || otherConditionsWithSameDatafield.length == 0;

        if (!isMatch) {
            allMatch = false;
        }
    });
    return allMatch;
}

export function getDatafieldLabel(dataField, currentLang) {
    if (!dataField) {
        return 'onbekend dataveld';
    }
    const translation = dataField.translations
        ? dataField.translations.label[currentLang]
        : null;
    let label = translation;
    if (!label || label.length == 0) {
        label = dataField.label;
    }
    if (!label || label.length == 0) {
        label = dataField.name;
    }
    if (!label || label.length == 0) {
        label = '#' + dataField.datafieldId;
    }
    label += dataField.inUse == 0 ? ' (inactief)' : '';
    return label;
}
